export const CTA_CONSTANTS = {
  description: [
    "Zadara Cloud delivers a comprehensive suite of cloud services tailored for modern enterprises and service providers. By integrating compute, storage, and networking solutions, Zadara enables businesses to transition from managing infrastructure to focusing on growth and innovation. The platform's global presence ensures low-latency access to resources, enhancing performance and reliability.",
  ],
  features: [
    {
      label: "Compute Services (zCompute)",
      text: "Secure and flexible compute resources that support cloud-native applications, GPU-powered workloads, and Kubernetes orchestration.",
    },
    {
      label: "Storage Services (zStorage)",
      text: "Enterprise-grade storage solutions offering block, file, and object storage with support for various protocols, ensuring seamless data management across different environments.",
    },
    {
      label: "Networking Services (zNetworking)",
      text: "Robust networking capabilities that provide secure and efficient connectivity for diverse applications and services.",
    },
  ],
  title: "What is Zadara Cloud?",
  extraContent:
    "By integrating these services, Zadara enables businesses to transition from managing infrastructure to focusing on growth and innovation. The platform's global presence ensures low-latency access to resources, enhancing performance and reliability.  ",
};
